import { FleekError } from './FleekError';

type InvalidDeploymentTriggerErrorOptions = Record<string, never>;

export class InvalidDeploymentTriggerError extends FleekError<InvalidDeploymentTriggerErrorOptions> {
  public name = 'InvalidDeploymentTriggerError';

  toString = () => `Deployment can not be triggered, source provider integrations missing.`;
}
